(window as any).global = window;
(window as any).process = { env: {} };

import 'zone.js/plugins/task-tracking';

// Optional: if some packages need Buffer
// import { Buffer } from 'buffer';
// (window as any).Buffer = Buffer;
